export default __webpack_public_path__ + "static/media/OTsurgeryConvert.569bb5f9.svg";